<template>
  <div class="d-book-gallery">
    <DExplicitOverlay
      v-if="containExplicit && contentIsHidden"
      button-text="Show gallery"
      @button-click="showContent"
    />

    <DuiGallery
      v-else
      class="background-grey"
      :images="vm.bookImages"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import DExplicitOverlay from '@d-components/d-explicit-overlay/d-explicit-overlay.vue';
import { getErrorMessage } from '@d-shared/utils/errors';

export default {
  components: {
    DExplicitOverlay,
  },
  props: {
    containExplicit: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    vm: {
      bookImages: [],
    },
  }),
  computed: {
    contentIsHidden() {
      return this.$store.getters['ExplicitContent/get-hidden-content'].gallery;
    },
  },
  mounted() {
    this.loadBookGalleryInfo();
  },
  methods: {
    loadBookGalleryInfo() {
      const bookGalleryInfoEl = document.getElementById('book-gallery-info');
      if (!bookGalleryInfoEl) {
        Vue.duiNotificationManager.error(getErrorMessage(null));
        return;
      }

      try {
        const galleryInfo = JSON.parse(bookGalleryInfoEl.dataset.gallery);
        bookGalleryInfoEl.remove();
        this.setGalleryImages(galleryInfo.illustration_attachments);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }
    },

    setGalleryImages(illustrationAttachments) {
      this.$set(this.vm, 'bookImages', illustrationAttachments.map(ia => ia.attachment.large.url));
    },

    showContent() {
      this.$store.dispatch('ExplicitContent/setGalleryVisibility', false);
    },
  },
};
</script>
